import {kGlossaryTexts} from "../../../constants/texts";
import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryDetailedScreenSubHeaderHighlighter({currentTab}) {
    // Used in GlossaryDetailedScreenSubHeader to display selected
    // tab

    // BUILD
    if (isNullOrUndefined(currentTab))
        return null
    return (
        <div className={`absolute top-[2px] bottom-[2px] left-[2px] bg-greenStar rounded-[5px] transition-transform duration-300 ease-in-out ${
            currentTab === kGlossaryTexts.definitionTab
                ? "translate-x-0 w-[calc(50%-2px)]"
                : "translate-x-[100%] w-[calc(50%-2px)]"}`} />
    );
}